import "./App.css";
import HttpDataFetch from "./components/HttpDataFetch";
import Header from "./components/Header";

function App() {
  return (
    <div>
      <Header />
      <HttpDataFetch />
    </div>
  );
}

export default App;
